import { useSelector } from "react-redux";
import { PageHeaderUi } from "../ui/PageHeaderUi";
import { EntradaScreen } from "./movimientos/entrada/EntradaScreen";
import { SalidaScreen } from "./movimientos/salida/SalidaScreen";
import { TrasladoScreen } from "./movimientos/traslado/TrasladoScreen";
import { RemoveScreen } from "./movimientos/remover/RemoveScreen";
import { Col, Row } from "antd";
import { InventarioSeachForm } from "./InventarioSeachForm";
import { InventarioProductoTable } from "./InventarioProductoTable";

const InventarioProductoListScreen = () => {
  const { inventariosProducto, paginator, loading } = useSelector(
    (state) => state.inventario,
  );
  return (
    <PageHeaderUi title="Existencias" subTitle="Listado">
      <div style={{ overflow: "hidden" }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={24}>
            <InventarioSeachForm />
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={24}>
            <InventarioProductoTable
              data={inventariosProducto}
              loading={loading}
              paginator={paginator}
            />
          </Col>
        </Row>
      </div>
    </PageHeaderUi>
  );
};

export const InventarioProductoList = () => {
  const {
    visibleFormInput,
    visibleFormOutput,
    visibleFormTransfer,
    visibleFormRemove,
  } = useSelector((state) => state.inventario);
  if (visibleFormInput) {
    return <EntradaScreen />;
  } else if (visibleFormOutput) {
    return <SalidaScreen />;
  } else if (visibleFormTransfer) {
    return <TrasladoScreen />;
  } else if (visibleFormRemove) {
    return <RemoveScreen />;
  } else {
    return <InventarioProductoListScreen />;
  }
};

export default InventarioProductoList;
